export {VEGA_SPECS, VEGA_LITE_SPECS} from './specs.js';

export * from './consts.js';
export {DEFAULT_STATE} from './default-state.js';
